/** saves operators
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operators
*/
export const SAVE_OPERATORS = (state, payload) => {
    state.operatorsList = payload
}

/** saves operations type
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationstypes
*/
export const SAVE_OPERATIONS_TYPES = (state, payload) => {
    state.operationsTypesList = payload
}

/** saves accounts
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const SAVE_ACCOUNTS = (state, payload) => {
    state.accounts = payload
}

/** saves profiles
@payload { array } - Não há
*/
export const SAVE_PROFILES = (state, payload) => {
    state.profiles = payload.map(profile => {
        return {
            ...profile,
            mdwId: profile.id,
            id: profile.id === 3 ? 4 : profile.id
        }
    })
}

/** saves plafonds and limits
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsplafondsandlimits
*/
export const SAVE_PLAFONDS_LIMITS = (state, payload) => {
    state.plafondsAndLimits = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.operatorsList = []
}
